'use strict';
/**
 * This is an enhancement of the enhanced-http service.
 *
 *
 */
angular.module('autoremind.services')
    .factory('$httpQueue', ['$q', '$enhancedHttp', '$rootScope', '$interval', '$timeout', function ($q, $enhancedHttp, $rootScope, $interval, $timeout) {
        var queueOfRequests = function () {
            console.log('queueOfRequests');
            this.queue = {};
            this.pending = {};
        };
        queueOfRequests.prototype.addToQueue = function (config, loadingIndicator, defer) {
            var requestTime = new Date().getTime();
            var queueKey = config.stacking.label;
            if (angular.isDefined(config.stacking.type)) {
                queueKey += '-' + config.stacking.type;
            }
            if (!angular.isDefined(this.queue[queueKey])) {
                this.queue[queueKey] = [];
                this.pending[queueKey] = [];
                this.initQueueWatcher(queueKey);
            }
            var deferred = (angular.isDefined(defer)) ? defer : $q.defer();
            this.queue[queueKey].push({
                deferred: deferred,
                time: requestTime,
                config: config,
                loadingIndicator: loadingIndicator,
                response: null,
                isExecuted: false
            });
            return deferred.promise;
        };
        queueOfRequests.prototype.initQueueWatcher = function (key) {
            var self = this;
            var listener;
            listener = $rootScope.$watch(angular.bind(this, function () {
                return this.queue[key];
            }), function (newVal) {
                if (!angular.isDefined(newVal)) {
                    listener();
                    return;
                }
                var countOfResponses = 0;
                for (var i in self.queue[key]) {
                    if (self.queue[key][i].response) {
                        countOfResponses++;
                    }
                    if (self.queue[key][i].isExecuted)
                        continue;
                    self.queue[key][i].isExecuted = true;
                    $enhancedHttp(self.queue[key][i].config, self.queue[key][i].loadingIndicator)
                        .then(function (res) {
                        self.queue[key][i].response = {
                            type: 'success',
                            data: res
                        };
                    }, function (err) {
                        self.queue[key][i].response = {
                            type: 'error',
                            data: err
                        };
                    });
                }
                if (countOfResponses === self.queue[key].length) {
                    listener();
                    self.checkResponses(key);
                }
            }, true);
        };
        queueOfRequests.prototype.checkResponses = function (key) {
            var newKey = key + new Date().getTime();
            this.pending[newKey] = angular.copy(this.queue[key]);
            delete this.queue[key];
            this.pending[newKey].sort(function (a, b) {
                return a.time - b.time;
            });
            var mainRequestId = false;
            for (var i in this.pending[newKey]) {
                if (angular.isDefined(this.pending[newKey][i].response.data.rejectedInUse) &&
                    this.pending[newKey][i].response.data.rejectedInUse) {
                    mainRequestId = i;
                }
                if (this.pending[newKey].length - 1 === parseInt(i) && !mainRequestId) {
                    mainRequestId = i;
                }
            }
            this.applyRequests(newKey, mainRequestId);
        };
        queueOfRequests.prototype.applyRequests = function (queueName, mainRequestId) {
            for (var i in this.pending[queueName]) {
                if (i !== mainRequestId) {
                    this.pending[queueName][i].deferred.resolve({ rejectedFromQueue: true });
                    continue;
                }
                if (angular.isDefined(this.pending[queueName][i].response.data.rejectedInUse) &&
                    this.pending[queueName][i].response.data.rejectedInUse &&
                    !this.pending[queueName][i].config.isSecondRequest &&
                    this.pending[queueName].length > 1) {
                    var requestDataToResend = angular.copy(this.pending[queueName][i]);
                    requestDataToResend.config.isSecondRequest = true;
                    this.addToQueue(requestDataToResend.config, requestDataToResend.loadingIndicator, requestDataToResend.deferred);
                    continue;
                }
                if (this.pending[queueName][i].response.type === 'success') {
                    this.pending[queueName][i].deferred.resolve(this.pending[queueName][i].response.data);
                }
                else {
                    this.pending[queueName][i].deferred.reject(this.pending[queueName][i].response.data);
                }
            }
            delete this.pending[queueName];
        };
        var adapter = new queueOfRequests();
        return function (config, loadingIndicator) {
            return adapter.addToQueue(config, loadingIndicator);
        };
    }]);
//# sourceMappingURL=http-queue.js.map